// !WARNING! This file is auto-generated by /scripts/generateIconsImport.ts, so all your modifications would be replaced.
import { fontAwesomeIcons, FontAwesomeSource, FontAwesomeIconData } from './icons/fontAwesome'
export * from './icons/fontAwesome'
export type IconSource = FontAwesomeSource
export const icons: (FontAwesomeIconData)[] = [
  ...fontAwesomeIcons
]
